import { Component, Input, OnInit } from '@angular/core';
import { CustomPropertyService } from 'src/app/custom-properties/services/custom-property.service';
import { ProjectQuery } from 'src/app/projects/state/project.query';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { FileDownload } from '../model/file-download.model';
import { ResultDownloadService } from '../service/result-download.service';
import { finalize, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AppError } from 'src/app/core/errors/http-error/app-error';

@Component({
  selector: 'app-result-download-form',
  templateUrl: './result-download-form.component.html',
  styleUrls: ['./result-download-form.component.scss']
})
export class ResultDownloadFormComponent implements OnInit {

  @Input()
  element: FileDownload;
  hasParams: boolean;
  isLoading: boolean;
  error: AppError;

  constructor(
    private customPropertyService: CustomPropertyService,
    private resultDownloadService: ResultDownloadService,
    private projectQuery: ProjectQuery,
    private simulationQuery: SimulationQuery
  ) { }

  ngOnInit(): void {
    if (this.element.request_parameters) {
      this.hasParams = Object.keys(this.element.request_parameters).length > 0;
      if (this.hasParams) {
        this.customPropertyService.loadForm({}, this.element.request_parameters);
      }
    }
  }

  requestResult() {
    const projectId = this.projectQuery.getActiveId();
    const simulationId = this.simulationQuery.getActiveId();
    const data = this.customPropertyService.getData();
    this.resultDownloadService.request(projectId, simulationId, this.element.id, data)
      .pipe(
        catchError(error => {
          this.error = error;
          return throwError(error);
        }),
        finalize(() => this.isLoading = false)
      )
      .subscribe(result => {
        this.element = result as FileDownload;
      });
  }

}
